import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { WebhookStaging } from "@app/models/rest/webhook-staging";

@Injectable({
  providedIn: "root"
})
export class WebhookStagingRestService extends HateoasResourceOperation<WebhookStaging> {
  constructor() {
    super(WebhookStaging);
  }
}
